<template>
  <vuedraggable class="tree-element" v-loading="loading" handle=".icon_1" element="div" v-bind="dragOptions()" @update="end" @add="end" :list="dataset">
    <div class="child" handle=".icon_1" element="div" v-bind="dragOptions(item)"  v-for="(item, index) in dataset" :key="item.id">
      <div class="item" :key="item.id" :class="{'level_1': item.level === 1, 'active': active === item.id}" :style="{'padding-left': 50 + (item.level - 1) * 24 + 'px'}" @click="selectElement(item)">
        <i class="icon iconfont iconicon_drag_order icon_1 tableIconHover"></i>
        <div class="icon_2 tableIconHover">
          <i class="icon iconfont iconicon_drop_down_arrow" :class="{'rota90': item.open}" v-if="item.children && item.children.length > 0" @click.stop="item.open = !item.open"></i>
        </div>
        <toolTip class="title" :title="item.title">
          <template v-if="item.icon">
            <i class="icon iconfont icon_3" :class="{[item.icon]: true}" :style="{'color': item.color}"></i>
          </template>
          <template v-else>
            <i class="icon iconfont iconicon_folder icon_3" v-if="item.level === 1"></i>
            <i v-else class="icon iconfont iconicon_document icon_3"></i>
          </template>
          <span>{{item.title}}</span>
        </toolTip>
        <div class="right">
          <el-tooltip class="tip-item" effect="dark" content="新建文档" placement="bottom" @click.native.stop="check(item.id)" v-if="item.level === 1">
            <i class="icon iconfont iconicon_new_document tableIconHover"></i>
          </el-tooltip>
          <div class="wait-release" v-if="item.release_status === 2 && item.level > 1">待发布</div>
          <div class="draft" v-if="item.release_status === 1 && item.level > 1">草稿</div>
          <!-- <CheckBoxPopover class="tip-item" @click.native.stop v-model="item.permissions" v-if="item.level > 1"></CheckBoxPopover> -->
          <el-tooltip class="tip-item" effect="dark" content="编辑" placement="bottom" @click.native.stop="editTitle(item)" v-if="item.release_status !== 2">
            <i class="icon iconfont iconicon_input icon_5 tableIconHover"></i>
          </el-tooltip>
          <el-tooltip class="tip-item" effect="dark" content="删除" placement="bottom" @click.native.stop="delItem(item, index)">
            <i class="icon iconfont iconicon_delete icon_4 tableIconHover" ></i>
          </el-tooltip>
        </div>
      </div>
      <el-collapse-transition :key="item.id">
        <List v-if="item.open" :pid="item.id" :listData="item.children" :active="active" :level="item.level + 1"></List>
      </el-collapse-transition>
    </div>
    <nothing :config="{tip: '暂无内容'}" v-if="!loading && dataset.length === 0 && !pid"></nothing>
  </vuedraggable>
</template>
<script>
import api from '@/services/api/help/help'
import bus from '@/bus'
import vuedraggable from 'vuedraggable'
import CheckBoxPopover from '../../components/checkBoxPopover'
export default {
  name: 'List',
  props: ['pid', 'listData', 'active', 'level'],
  components: {
    vuedraggable,
    CheckBoxPopover
  },
  data() {
    return {
      loading: false,
      dataset: [],
    }
  },
  destroyed() {
    // bus.$off('treeElementAdd')
  },
  watch: {
    listData: {
      handler() {
        this.dataset = this.listData || []
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    check(id) {
      bus.$emit('checkDocument', id)
    },
    dragOptions() {
      return {
        animation: 200,
        group: this.level,
      }
    },
    async end(item) {
      let newIndex = item.newIndex
      this.dataset[newIndex].pid = this.pid || 0
      this.dataset[newIndex].level = this.level || 0
      let id = this.dataset[newIndex].id
      let previous_id = this.dataset[newIndex - 1]?.id || 0
      let next_id = this.dataset[newIndex + 1]?.id || 0
      let pid = this.pid
      console.log(this.dataset)
      await api.documentUpdateSort({id, previous_id, next_id, pid: pid || 0})
    },
    async delItem(item){
      await this.$wfAlert('', '确认删除该内容？')
      await api.documentDelete({id: item.id})
      bus.$emit('delDocument', item)
    },
    selectElement(item) {
      if((item.children && item.children.length > 0) || item.level == 1) {
        item.open = !item.open
      } else {
        bus.$emit('treeSelectElement', item)
      }
    },
    editTitle(item) {
      bus.$emit('editDocument', item)
    },
  }
}
</script>
<style lang="scss">
.tree-element {
  min-height: 1px;
  .item {
    height: 40px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    position: relative;
    font-size: 14px;
    justify-content: space-between;
    padding-right: 16px;
    border-radius: 4px;
    cursor: pointer;
    i {
      font-size: 14px;
    }
    .icon_1, .icon_2 {
      position: absolute;
    }
    .icon_1 {
      left: 6px;
      color: rgba(32, 32, 32, 0.4);
      visibility: hidden;
    }
    .icon_2 {
      left: 24px;
      color: rgba(32, 32, 32, 0.24);
      i {
        transition: all .3s;
      }
    }
    .icon_3 {
      color: rgba(32, 32, 32, 0.6);
      margin-right: 9px;
    }
    .title {
      width: 0;
      flex: 1;
    }
    .right {
      i {
        color: rgba(32, 32, 32, 0.6);
      }
      .tip-item {
        visibility: hidden;
      }
      .icon_4 {
        display: none;
        color: #FF3939;
        font-size: 14px;
      }
      .icon_5 {
        display: none;
        font-size: 14px;
      }
    }
    &:hover {
      .icon_1, .icon_2, .tip-item {
        visibility: visible;
      }
      .right .icon_4, .right .icon_5 {
        display: initial;
      }
      .right {
        .wait-release, .draft {
          display: none;
        }
      }
      background-color: rgba(32, 32, 32, 0.04);
    }
    &.active {
      background-color: rgba(32, 32, 32, 0.08);
    }
    &.level_1 {
      .title {
        font-size: 16px;
      }
    }
    .wait-release {
      font-size: 12px;
      background: rgba(255,152,0,0.16);
      border-radius: 4px;
      height: 24px;
      padding: 0 8px;
      display: inline-flex;
      align-items: center;
      font-weight: 400;
      color: #FF9800;
    }
    .draft {
      font-size: 12px;
      background: rgba(32,32,32,0.08);
      border-radius: 4px;
      height: 24px;
      padding: 0 8px;
      display: inline-flex;
      align-items: center;
      font-weight: 400;
      color: rgba(32, 32, 32, 0.6);
    }
  }
}
</style>
